// extracted by mini-css-extract-plugin
export var acitonButtons = "_hq-0";
export var additionalIcon = "_hq-f";
export var block = "_hq-1";
export var blockContent = "_hq-7";
export var blockDescription = "_hq-8";
export var blockIcon = "_hq-9";
export var blockTitle = "_hq-6";
export var border = "_hq-a";
export var center = "_hq-l";
export var edge = "_hq-b";
export var edgeLabel = "_hq-c";
export var edgePath = "_hq-d";
export var error = "_hq-e";
export var flowchart = "_hq-g";
export var flowchartContent = "_hq-h";
export var highlighted = "_hq-3";
export var hover = "_hq-4";
export var icon = "_hq-i";
export var left = "_hq-m";
export var navButton = "_hq-j";
export var navButtons = "_hq-k";
export var right = "_hq-n";
export var selected = "_hq-2";
export var small = "_hq-5";